import React, { memo, useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { Button, Col, Row, Space, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { hideModal } from '@/store/actions/modalsActions';
import Modal from '@/views/modals/Modal';
import statusType from '@/store/constants/statusType';
import { TENDER_ACTION } from '@/constants/tender';

import { MODALS } from '..';

import classes from './ConfirmTenderReady.module.scss';

const { Title, Text } = Typography;

const ConfirmTenderReady = props => {
  const { onOk } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const status = useSelector(state => state.company?.[TENDER_ACTION.MOVE_TO_READY]?.status);

  const handleClickNo = useCallback(() => {
    dispatch(hideModal(MODALS.ConfirmTenderReady));
  }, [dispatch]);

  const handleClickYes = useCallback(() => {
    if (onOk) {
      onOk();
    }
  }, [onOk]);

  return (
    <Modal name={MODALS.ConfirmTenderReady} width={468}>
      <Row gutter={[0, 22]}>
        <Col span={24}>
          <Title level={4}>{t('modal.confirm-tender-ready.title')}</Title>
          <Text className={classes.description}>{t('modal.confirm-tender-ready.description')}</Text>
        </Col>
        <Col span={24}>
          <Row justify="end">
            <Space>
              <Button shape="round" onClick={handleClickNo}>
                {t('modal.confirm-tender-ready.button.no')}
              </Button>
              <Button type="primary" shape="round" loading={status === statusType.LOADING} onClick={handleClickYes}>
                {t('modal.confirm-tender-ready.button.yes')}
              </Button>
            </Space>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default memo(ConfirmTenderReady);
